<template>
  <el-container class="admin-layout">
    <el-aside width="220px" class="admin-aside">
      <div class="admin-logo">管理端</div>
      <el-menu
        :default-active="activeMenu"
        router
        class="admin-menu"
        background-color="#001529"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="/admin/dashboard">
          <i class="el-icon-menu"></i>
          <span slot="title">仪表盘</span>
        </el-menu-item>

        <!-- 影传模块 -->
        <el-submenu index="/admin/yingchuan">
          <template slot="title">
            <i class="el-icon-upload"></i>
            <span>影传</span>
          </template>
          <el-menu-item index="/admin/yingchuan/logs">
            <i class="el-icon-document"></i>
            <span slot="title">日志</span>
          </el-menu-item>
          <el-menu-item index="/admin/yingchuan/users">
            <i class="el-icon-user"></i>
            <span slot="title">用户数据</span>
          </el-menu-item>
        </el-submenu>

        <!-- 影控模块（建设中，先占位） -->
        <el-submenu index="/admin/yingkong">
          <template slot="title">
            <i class="el-icon-video-camera"></i>
            <span>影控</span>
          </template>
          <el-menu-item index="/admin/yingkong">
            <i class="el-icon-loading"></i>
            <span slot="title">模块建设中</span>
          </el-menu-item>
        </el-submenu>

        <!-- 协议页面管理 -->
        <el-menu-item index="/admin/policies">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">协议页面管理</span>
        </el-menu-item>
        <!-- 后续功能模块在此追加 el-menu-item / el-submenu -->
      </el-menu>
      <div class="admin-aside-foot">
        <span class="admin-username">{{ auth.user ? auth.user.name : '' }}</span>
        <el-button type="text" class="admin-logout" @click="onLogout">退出登录</el-button>
      </div>
    </el-aside>

    <el-container>
      <el-main class="admin-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import auth from '../auth'

export default {
  name: 'AdminLayout',
  computed: {
    auth() {
      return auth
    },
    activeMenu() {
      return this.$route.path
    },
  },
  methods: {
    onLogout() {
      auth.logout()
      this.$router.replace('/admin/login')
    },
  },
}
</script>

<style scoped>
.admin-layout {
  height: 100vh;
}
.admin-aside {
  background: #001529;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.admin-logo {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 18px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.admin-menu {
  flex: 1;
  border-right: none;
  overflow: auto;
}
.admin-aside-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.admin-username {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
}
.admin-logout {
  color: #ffd04b !important;
}
.admin-main {
  background: #f0f2f5;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/admin/layouts/AdminLayout.vue